import { DataTable, RecordField } from "@/components/admin"
import { Badge } from "@/components/ui/badge"
import List from "@/modules/users/components/List"
import { CircleUser, Fingerprint } from "lucide-react"
const ContractsList: React.FC = () => {
  return (
    <List>
      <DataTable.Col label="Rôle">
        <RecordField
          source="user_role"
          label=""
          render={record =>
            record.user_role && (
              <Badge className="px-2 py-1 rounded-full border-none bg-green-600/10 text-green-600 focus-visible:ring-green-600/20 focus-visible:outline-none dark:bg-green-400/10 dark:text-green-400 dark:focus-visible:ring-green-400/40 [a&]:hover:bg-green-600/5 dark:[a&]:hover:bg-green-400/5">
                <CircleUser className="size-4" />
                {record.user_role}
              </Badge>
            )
          }
          empty={
            <Badge className="bg-destructive/10 [a&]:hover:bg-destructive/5 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 text-destructive rounded-full border-none focus-visible:outline-none">
              <span
                className="bg-destructive size-1.5 rounded-full"
                aria-hidden="true"
              />
              contrat incomplet
            </Badge>
          }
        />
      </DataTable.Col>
      <DataTable.Col label="Nom d'utilisateur">
        <RecordField
          source="username"
          label=""
          render={record =>
            record.username && (
              <Badge className="px-2 py-1 rounded-full border-none bg-gray-600/10 text-gray-600 focus-visible:ring-gray-600/20 focus-visible:outline-none dark:bg-gray-400/10 dark:text-gray-400 dark:focus-visible:ring-green-400/40 [a&]:hover:bg-gray-600/5 dark:[a&]:hover:bg-gray-400/5">
                <Fingerprint className="size-4" />
                {record.username}
              </Badge>
            )
          }
          empty={
            <Badge className="bg-destructive/10 [a&]:hover:bg-destructive/5 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 text-destructive rounded-full border-none focus-visible:outline-none">
              <span
                className="bg-destructive size-1.5 rounded-full"
                aria-hidden="true"
              />
              contrat incomplet
            </Badge>
          }
        />
      </DataTable.Col>
    </List>
  )
}

export default ContractsList
